import { Gitlab, Slack, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 mt-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <div className="font-heading text-lg font-bold tracking-tight">
            CareStack<span className="text-[#2FCC7C]">.</span>AI-Skill Challenge
          </div>
          <p className="mt-2 text-xs font-mono uppercase tracking-widest text-zinc-500">
            An internal hackathon · Powered by curiosity
          </p>
        </div>
        <div className="flex items-center gap-3">
          <a
            href="https://gitlab.infra.aws.carestack.com/carestack/carestack.skills"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-github"
            title="carestack.skills repo"
            className="w-10 h-10 rounded-full glass flex items-center justify-center hover:border-[#2FCC7C]/50 transition-colors"
          >
            <Gitlab className="w-4 h-4 text-zinc-300" />
          </a>
          <a
            href="#"
            data-testid="footer-slack"
            className="w-10 h-10 rounded-full glass flex items-center justify-center hover:border-[#2FCC7C]/50 transition-colors"
          >
            <Slack className="w-4 h-4 text-zinc-300" />
          </a>
          <a
            href="#"
            data-testid="footer-mail"
            className="w-10 h-10 rounded-full glass flex items-center justify-center hover:border-[#2FCC7C]/50 transition-colors"
          >
            <Mail className="w-4 h-4 text-zinc-300" />
          </a>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-5 flex items-center justify-between text-[11px] font-mono text-zinc-600">
          <span>© {new Date().getFullYear()} CareStack · internal event</span>
          <span className="hidden md:inline">v1.0 · built for builders</span>
        </div>
      </div>
    </footer>
  );
}
